/*
 *     Copytop (c) 2020 Bcame S.r.l.. All tops reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <transition leave-active-class="animate__animated animate__fadeOut">
    <div class="wrapp-topbar" v-show="showTopBar">
      <transition
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      @after-leave="showTopBar = false">
        <div v-show="startAnimation" class="topbar-overlay" @click="closeTopBar"></div>
      </transition>
      <transition
      enter-active-class="animate__animated animate__fadeIn animate__slideInDown animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__slideOutUp animate__faster"
      @before-enter="startAnimation = showTopBar = true"
      @after-enter="toggleContent(true)"
      @before-leave="toggleContent(false)"
      @after-leave="startAnimation = false">
        <div class="wrapp-topbar__content" v-show="topActiveComponent.component" :class="dynamicClass" ref="topBar">
          <div class="wrapp-topbar__content__body">
            <transition
            enter-active-class="animate__animated animate__fadeIn animate__delay_0.4s"
            leave-active-class="animate__animated animate__fadeOut">
              <div class="wrapp-topbar__content__body__dynamic" v-show="showContent" :key="topActiveComponent.id">
                <component :is="topActiveComponent.component" v-bind="topActiveComponent.props"></component>
              </div>
            </transition>
          </div>
        </div>
      </transition>
      <transition
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut">
        <div v-show="startAnimation" class="wrapp-topbar__footer">
          <button class="bcm-close" @click="closeTopBar">
            <span></span>
            <span></span>
          </button>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TopNavigation',
  props: {
    showGoBack: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showContent: false,
      showTopBar: false,
      startAnimation: false
    }
  },
  computed: {
    topNavHistory () {
      return this.$store.state.ui.topNavHistory
    },
    topActiveComponent () {
      let activeComp = this.$store.getters['ui/getTopActiveComponent']
      if (process.client) {
        let $header = $('.bcm-whole-header')
        if ($('body').hasClass('scroll-up')) {
          // mini header visible calc its height
          $header = $('.fixed-header')
        }
        $header.toggleClass('on-submenu', !!activeComp.component)
        if (this.$refs.topNavScrollbar) {
          const osInstance = this.$refs.topNavScrollbar.osInstance()
          osInstance.scrollStop().scroll(0)
        }
        if (activeComp.component && this.$refs.topBar) {
          let headerHeight = $header.outerHeight()
          $(this.$refs.topBar).css({
            'padding-top': headerHeight
          })
        }
      }
      return activeComp
    },
    dynamicClass () {
      let classObj = {}
      let topActiveComponent = this.$store.state.ui.topActiveComponent
      if (topActiveComponent && topActiveComponent.component && topActiveComponent.component.name) {
        classObj = {
          [`component-active-${topActiveComponent.component.name.toLowerCase()}`]: true
        }
      }
      return classObj
    }
  },
  methods: {
    closeTopBar () {
      this.animation = false
      this.$store.commit('ui/setTopActiveComponent', {})
    },
    goBackHistory () {
      this.$store.dispatch('ui/loadTopActiveComponent', { isBack: true })
    },
    toggleContent (toggle) {
      this.showContent = toggle
      this.startAnimation = toggle
    }
  }
}
</script>
